module.exports = __webpack_public_path__ + "static/image3-cb41aa63ec74df397c124b7b1c83b572.jpg";